import type { ReactNode } from "react";

import * as styles from "./feedback.scss";

interface FeedbackCopyProps {
	children?: ReactNode;
}

export const FeedbackCopy = ({ children }: FeedbackCopyProps) => {
	return <p className={styles.paragraph}>{children}</p>;
};
